import { Core, Localization, Typography } from 'connex-cds';
import { useCallback, useEffect } from 'react';
import useThemeConfig from '../useThemeConfig';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { tickets } from '../../../../../api';
import { useListDriverTickets, isPendingTicket, findNextPendingDriverTicket } from '../../../../../query-hooks/tickets';
import * as S from './styles';

const sendMessage = message => {
  window.postMessage(message, '*');
};

const ActiveTicket = () => {
  const { entityRef } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const excludeCrn = location?.state?.excludeCrn;

  const today = new Date();
  const yesterday = new Date();
  yesterday.setDate(today.getDate() - 1);

  const driverTickets = useListDriverTickets({
    queryParams: { startDate: yesterday?.toISOString(), endDate: today?.toISOString() },
  });

  const loadTicket = ticket => {
    if (ticket) {
      const message = { type: 'ticket', active: true, crn: ticket?.crn };
      navigate(`../${ticket?.vehicleId}`, {
        state: {
          type: 'ticket',
          active: true,
          crn: ticket?.crn,
        },
      });
      sendMessage(message);
    }
  };

  const findPendingTicket = useCallback(
    async () => findNextPendingDriverTicket(entityRef, excludeCrn),
    [entityRef, excludeCrn]
  );

  useEffect(() => {
    if (driverTickets?.data) {
      const ticket = driverTickets.data.findLast(item => isPendingTicket(item, excludeCrn));
      loadTicket(ticket);
    }
  }, [driverTickets]);

  useEffect(() => {
    const intervalId = setInterval(async () => {
      const ticket = await findPendingTicket();
      loadTicket(ticket);
    }, 60000);

    return () => clearInterval(intervalId);
  }, [findPendingTicket]);

  return (
    <Core.Spinner spin={tickets?.isLoading}>
      <S.FormStyle>
        <S.LabelStyle>
          <Typography.H1>
            <Localization.Translate stringId="waitingForTicket" data-testid="waitingForTicket" />
          </Typography.H1>
        </S.LabelStyle>
      </S.FormStyle>
    </Core.Spinner>
  );
};

export default useThemeConfig(ActiveTicket);
